import React, { createContext, useContext, useState, ReactNode } from 'react';

interface EmailTooltipContextType {
  showTooltip: (email: string, x: number, y: number) => void;
  hideTooltip: () => void;
  tooltipState: {
    isVisible: boolean;
    email: string;
    position: { x: number; y: number };
  };
}

const EmailTooltipContext = createContext<EmailTooltipContextType | undefined>(undefined);

export const EmailTooltipProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [tooltipState, setTooltipState] = useState({
    isVisible: false,
    email: '',
    position: { x: 0, y: 0 },
  });

  const showTooltip = (email: string, x: number, y: number) => {
    setTooltipState({
      isVisible: true,
      email,
      position: { x, y },
    });
  };

  const hideTooltip = () => {
    setTooltipState(prev => ({
      ...prev,
      isVisible: false,
    }));
  };

  return (
    <EmailTooltipContext.Provider value={{ showTooltip, hideTooltip, tooltipState }}>
      {children}
    </EmailTooltipContext.Provider>
  );
};

export const useEmailTooltip = () => {
  const context = useContext(EmailTooltipContext);
  if (context === undefined) {
    throw new Error('useEmailTooltip must be used within an EmailTooltipProvider');
  }
  return context;
}; 